/******/ (function() { // webpackBootstrap
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Section: Hero Video
 * ------------------------------------------------------------------------------
 * This will allow for playing and pausing native hero video
 *
 * @namespace Careers
 */
var Careers = /*#__PURE__*/function () {
  function Careers() {
    _classCallCheck(this, Careers);
    this.jobRequisitions = null; // Store job requisitions data
    this.init();
  }
  return _createClass(Careers, [{
    key: "init",
    value: function init() {
      this.adpDataEndpoint();
      this.setupHashChangeListener();
    }

    // Helper function to handleize a string (convert to URL-friendly format)
  }, {
    key: "handleize",
    value: function handleize(str) {
      return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
    }

    // Helper function to scroll to top smoothly
  }, {
    key: "scrollToTop",
    value: function scrollToTop() {
      window.scrollTo({
        top: 0
      });
    }
  }, {
    key: "adpDataEndpoint",
    value: function adpDataEndpoint() {
      var _this = this;
      fetch('/apps/adpJobRequisition/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: 'test'
        })
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        var allJobRequisitions = data.data.jobRequisitions;

        // Filter to only show jobs with requisitionStatusCode.codeValue === "ON"
        var jobRequisitions = allJobRequisitions.filter(function (job) {
          return job.requisitionStatusCode && job.requisitionStatusCode.codeValue === 'ON';
        });
        console.log('jobRequisitions', jobRequisitions);

        // Store job requisitions for hash change handling
        _this.jobRequisitions = jobRequisitions;
        _this.jobListingBuildFilter(jobRequisitions);
        _this.jobListingBuild(jobRequisitions);
        document.querySelector('.careers__page-loading').classList.remove('careers__page-loading--active');

        // Check if there's a hash in the URL and open the corresponding job
        _this.checkUrlHashAndOpenJob(jobRequisitions);
      }).catch(function (error) {
        console.error('Error:', error);
        document.querySelector('.careers__page-loading').classList.remove('careers__page-loading--active');
      });
    }

    // Check URL hash and open corresponding job if it exists
  }, {
    key: "checkUrlHashAndOpenJob",
    value: function checkUrlHashAndOpenJob(jobRequisitions) {
      var _this2 = this;
      var hash = window.location.hash.substring(1); // Remove the # symbol
      if (hash) {
        var job = jobRequisitions.find(function (job) {
          var jobHandle = _this2.handleize(job.job.jobTitle);
          return jobHandle === hash;
        });
        if (job) {
          this.renderJobView(jobRequisitions, job.itemID);
        }
      } else {
        // Hash is empty, show the job listings
        document.querySelector('.careers__container').classList.remove('hidden');
        document.querySelector('[js-careers-adp="job"]').classList.add('hidden');
      }
    }
  }, {
    key: "jobListingBuildFilter",
    value: function jobListingBuildFilter(jobRequisitions) {
      var _this3 = this;
      var jobFilter = document.querySelector('[js-careers-adp="job-listings-filter"]');
      var jobRequisitionsMap = new Map();

      // Filter out Production Manager jobs and jobs without external links before building location filters
      var filteredJobRequisitions = jobRequisitions.filter(function (job) {
        if (!job || !job.job) {
          // console.log('Filtered out job: Invalid job data');
          return false;
        }
        if (!job.links || !job.links.some(function (link) {
          return link.title && link.title.includes('External');
        })) {
          // console.log(`Filtered out job: "${job.job.jobTitle}" - No external link found`);
          return false;
        }
        return true;
      });
      filteredJobRequisitions.forEach(function (job) {
        var location = job.requisitionLocations[0].address;
        var key = "".concat(location.cityName);
        if (!jobRequisitionsMap.has(key)) {
          jobRequisitionsMap.set(key, {
            city: location && location.cityName || '',
            state: location && location.countrySubdivisionLevel1 && location.countrySubdivisionLevel1.codeValue || '',
            country: location && location.countryCode || ''
          });
        }
      });
      var updateActiveClass = function updateActiveClass(clickedButton) {
        document.querySelectorAll('.careers__filter-button').forEach(function (btn) {
          return btn.classList.remove('careers__filter-button--active');
        });
        clickedButton.classList.add('careers__filter-button--active');
      };
      jobRequisitionsMap.forEach(function (location) {
        var jobListingFilterButton = document.createElement('button');
        jobListingFilterButton.classList.add('careers__filter-button');
        var locationParts = [location && location.city, location && location.state, location && location.country].filter(function (part) {
          return part && part.trim() !== '';
        });
        jobListingFilterButton.textContent = locationParts.join(', ').replace('London, London, City of, GB', 'London, London, City of GB');
        jobListingFilterButton.addEventListener('click', function () {
          updateActiveClass(jobListingFilterButton);
          _this3.jobListingFiltered(_this3.jobRequisitions, location);
        });
        jobFilter.appendChild(jobListingFilterButton);
      });

      // "Show All" Button
      var showAllButton = document.createElement('button');
      showAllButton.classList.add('careers__filter-button');
      showAllButton.classList.add('careers__filter-button--active');
      showAllButton.textContent = 'All openings';
      showAllButton.addEventListener('click', function () {
        updateActiveClass(showAllButton);
        _this3.jobListingBuild(jobRequisitions);
      });
      jobFilter.prepend(showAllButton);
    }
  }, {
    key: "jobListingFiltered",
    value: function jobListingFiltered(jobRequisitions, filter) {
      if (!filter) {
        console.error('Filter is undefined');
        return;
      }
      var filteredJobs = jobRequisitions.filter(function (job) {
        var location = job.requisitionLocations[0].address;
        return location.cityName === (filter && filter.city) && (location.countrySubdivisionLevel1 && location.countrySubdivisionLevel1.codeValue) === (filter && filter.state) && location.countryCode === (filter && filter.country);
      });
      this.jobListingBuild(filteredJobs);
    }
  }, {
    key: "jobListingBuild",
    value: function jobListingBuild(jobRequisitions) {
      var jobListingContainer = document.querySelector('[js-careers-adp="job-listings"]');
      jobListingContainer.innerHTML = '';

      // Filter out Production Manager jobs and jobs without external links
      var filteredJobRequisitions = jobRequisitions.filter(function (jobListing) {
        if (!jobListing || !jobListing.job) {
          console.log('Filtered out job: Invalid job data');
          return false;
        }
        if (!jobListing.links || !jobListing.links.some(function (link) {
          return link.title && link.title.includes('External');
        })) {
          console.log("Filtered out job: \"".concat(jobListing.job.jobTitle, "\" - No external link found"));
          return false;
        }
        return true;
      });
      if (filteredJobRequisitions.length === 0) {
        jobListingContainer.innerHTML = '<p>No jobs found for this location.</p>';
        return;
      }
      filteredJobRequisitions.forEach(function (jobListing) {
        var cityName = jobListing && jobListing.requisitionLocations && jobListing.requisitionLocations[0] && jobListing.requisitionLocations[0].address && jobListing.requisitionLocations[0].address.cityName;
        var countrySubdivisionLevel1 = jobListing && jobListing.requisitionLocations && jobListing.requisitionLocations[0] && jobListing.requisitionLocations[0].address && jobListing.requisitionLocations[0].address.countrySubdivisionLevel1 && jobListing.requisitionLocations[0].address.countrySubdivisionLevel1.codeValue;
        var countryCode = jobListing && jobListing.requisitionLocations && jobListing.requisitionLocations[0] && jobListing.requisitionLocations[0].address && jobListing.requisitionLocations[0].address.countryCode;
        var projectedStartDate = jobListing && jobListing.projectedStartDate;
        var jobListingTile = "\n        <div\n          class=\"careers__listing\"\n          js-careers-adp=\"view-job\"\n          js-careers-adp-id=\"".concat(jobListing && jobListing.itemID, "\"\n        >\n          <div class=\"careers__title-container\">\n            <p class=\"careers__title\">\n              ").concat(jobListing && jobListing.job && jobListing.job.jobTitle, "\n            </p>\n\n\n            <p class=\"careers__location\">\n              ").concat(cityName != undefined ? "".concat(cityName, ", ") : '', "\n              ").concat(countrySubdivisionLevel1 != undefined ? "".concat(countrySubdivisionLevel1, ", ") : '', "\n              ").concat(countryCode, " | \n              ").concat(projectedStartDate != undefined ? projectedStartDate : '', "\n            </p>\n          </div>\n\n          <button\n            class=\"careers__button\"\n          >\n            view position\n          </button>\n        </div>\n      ");
        jobListingContainer.insertAdjacentHTML('beforeend', jobListingTile);
      });
      this.jobViewClicked(jobRequisitions);
    }
  }, {
    key: "jobViewClicked",
    value: function jobViewClicked(jobRequisitions) {
      var _this4 = this;
      document.querySelectorAll('[js-careers-adp="view-job"]').forEach(function (job) {
        var jobId = job.getAttribute('js-careers-adp-id');
        job.addEventListener('click', function () {
          _this4.renderJobView(jobRequisitions, jobId);
        });
      });
    }
  }, {
    key: "renderJobView",
    value: function renderJobView(jobRequisitions, jobId) {
      var foundKey = Object.keys(jobRequisitions).find(function (key) {
        return jobRequisitions[key].itemID === jobId;
      });
      var jobData = foundKey ? jobRequisitions[foundKey] : null;
      var jobContainer = document.querySelector('[js-careers-adp="job"]');
      jobContainer.classList.remove('hidden');
      jobContainer.innerHTML = '';
      var job = "\n      <button class=\"careers__job-back-button\" js-careers-adp=\"back\">\n        BACK TO OPENINGS\n      </button>\n\n      <h2 class=\"careers__job-title\">\n        ".concat(jobData && jobData.job && jobData.job.jobTitle, "\n      </h2>\n\n      <p class=\"careers__job-bold\">\n        ").concat(jobData && jobData.requisitionLocations && jobData.requisitionLocations[0] && jobData.requisitionLocations[0].address && jobData.requisitionLocations[0].address.cityName, ", \n        ").concat(jobData && jobData.requisitionLocations && jobData.requisitionLocations[0] && jobData.requisitionLocations[0].address && jobData.requisitionLocations[0].address.countrySubdivisionLevel1 && jobData.requisitionLocations[0].address.countrySubdivisionLevel1.codeValue, " \n        ").concat(jobData && jobData.requisitionLocations && jobData.requisitionLocations[0] && jobData.requisitionLocations[0].address && jobData.requisitionLocations[0].address.countryCode, "\n      </p>\n\n      <div class=\"careers__job-text\">\n        ").concat(jobData && jobData.postingInstructions && jobData.postingInstructions[0] && jobData.postingInstructions[0].nameCode && jobData.postingInstructions[0].nameCode.longName, "\n      </div>\n\n      <a\n        class=\"careers__job-link\"\n        href=\"").concat(jobData && jobData.links && jobData.links[1] && jobData.links[1].href || jobData && jobData.links && jobData.links[0] && jobData.links[0].href, "\"\n        target=\"_blank\"\n      >\n        Apply Now\n      </a>\n    ");
      document.querySelector('.careers__container').classList.add('hidden');
      jobContainer.innerHTML = job;

      // Scroll to top and update URL hash
      this.scrollToTop();
      var jobHandle = this.handleize(jobData && jobData.job && jobData.job.jobTitle);
      window.location.hash = jobHandle;
      this.backToOpening();
    }
  }, {
    key: "backToOpening",
    value: function backToOpening() {
      var back = document.querySelector('[js-careers-adp="back"]');
      back.addEventListener('click', function () {
        document.querySelector('.careers__container').classList.remove('hidden');
        document.querySelector('[js-careers-adp="job"]').classList.add('hidden');

        // Clear the hash when going back to listings
        window.location.hash = '';
      });
    }
  }, {
    key: "setupHashChangeListener",
    value: function setupHashChangeListener() {
      var _this5 = this;
      window.addEventListener('hashchange', function () {
        if (_this5.jobRequisitions) {
          _this5.checkUrlHashAndOpenJob(_this5.jobRequisitions);
        }
      });
    }
  }]);
}(); // Initialize HeroBanner instances
function initCareers() {
  document.querySelectorAll('[data-section-type="careers"]').forEach(function (banner) {
    if (!banner.heroBannerInstance) {
      banner.heroBannerInstance = new Careers(banner);
    }
  });
}

// Handle Shopify section events
document.addEventListener('shopify:section:load', function (event) {
  if (event.target.querySelector('[data-section-type="careers"]')) {
    initCareers();
  }
});

// Initialize on page load
document.addEventListener('DOMContentLoaded', initCareers);
/******/ })()
;